module.exports = __webpack_public_path__ + "static/media/21ECLAC49.5f656fad.jpg";